import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client'
import { SentryLink } from 'apollo-link-sentry'
import { cache } from './cache'
import { sentryOnErrorLink } from './sentryOnErrorLink'

const searchParams = new URLSearchParams(window.location.search)

export const client = new ApolloClient({
  link: ApolloLink.from([
    sentryOnErrorLink,
    new SentryLink({
      uri: import.meta.env.VITE_API_HOST,
      attachBreadcrumbs: {
        includeQuery: true,
        includeVariables: true,
        includeFetchResult: true,
        includeError: true
      },
      setTransaction: true
    }),
    new HttpLink({
      uri: import.meta.env.VITE_API_HOST,
      headers: {
        Authorization: `Bearer ${searchParams.get('auth')}`
      }
    })
  ]),
  cache
})
